import type { IConfigState } from './types'
import type { AppThunkDispatch } from '@/store'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { getTargetOmsConfig } from '@/utils'

const initialState: Partial<IConfigState> & { ready: boolean } = {
  ready: false,
}

const configSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setConfig(state, action: PayloadAction<IConfigState>) {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const { setConfig } = configSlice.actions

export const getConfig = async (dispatch: AppThunkDispatch, getState) => {
  /**
   * 有了就直接返回
   */
  if (typeof getState === 'function' && getState().configSlice.ready) {
    return getState().configSlice
  }

  const configRes = (await getTargetOmsConfig('oneship-config')) as IConfigState

  const config = {
    ready: true,
    ...configRes,
  }

  dispatch(setConfig(config))

  return config
}

export default configSlice.reducer
